/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { Col, Form, Input } from "antd";
import { ExpandableFilter } from "../../../components/ExpandableFilter";

interface FilterUserListProps {
  onSubmit: (values: any | undefined) => void;
}

interface UserFormInstance {
  name?: string;
}

const FilterUserList: FC<FilterUserListProps> = ({ onSubmit }) => {
  const [form] = Form.useForm<UserFormInstance>();

  const fields = [
    <Col span={8} key={1}>
      <Form.Item name={"name"} label={"Nome"}>
        <Input allowClear placeholder="Insira o nome" />
      </Form.Item>
    </Col>,
  ];

  const onFinish = (values: UserFormInstance) => {
    if (onSubmit) {
      onSubmit({ ...values });
    }
  };

  const onClear = () => {
    onSubmit(undefined);
  };

  return (
    <ExpandableFilter
      form={form}
      fields={fields}
      onFinish={onFinish}
      onClear={onClear}
    />
  );
};

export { FilterUserList };
